var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_notification",
    "data-name": "vuesax/bold/notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.524,10.408l-.833-1.383a3.1,3.1,0,0,1-.333-1.233V5.683A4.924,4.924,0,0,0,8.549,1.242,2.438,2.438,0,0,0,6.4,0,2.467,2.467,0,0,0,4.241,1.267a4.94,4.94,0,0,0-2.75,4.417V7.792a3.022,3.022,0,0,1-.333,1.225L.316,10.408A1.948,1.948,0,0,0,1.408,13.35a15.585,15.585,0,0,0,5.017.817,15.808,15.808,0,0,0,5.017-.808,2.01,2.01,0,0,0,1.083-2.95Z",
    transform: "translate(3.592 1.667)",
    fill: "#030014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.708.008A2.512,2.512,0,0,1,2.35,1.667,2.471,2.471,0,0,1,.583.925,2.3,2.3,0,0,1,0,0C.108.017.217.025.333.042c.192.025.392.05.592.067C1.4.15,1.883.175,2.367.175S3.317.15,3.783.108c.175-.017.35-.025.517-.05Z",
    transform: "translate(7.65 16.667)",
    fill: "#030014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.aea0c67dfe6299dd09417f6952f66014.svg";
export { ForwardRef as ReactComponent };